import React, {Component} from 'react';
import {observer} from 'mobx-react';
import CircularProgress from 'material-ui/CircularProgress';

const center_style = {
  height: '80%',
  padding: 0,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default
@observer class PageLoading extends Component {

  render() {
    if(this.props.loading) {
      return (
        <div style={center_style}>
          <CircularProgress mode="indeterminate" size={1} />
        </div>
      )
    } else {
      return (
        <div>{this.props.children}</div>
      )
    }
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/PageLoading.jsx
 **/